import { FC } from 'react'

import PerText from '../Text'
import PerSpacer from '../Spacer'
import PerFlexRow from '../FlexRow'
import BackgroundBox from '../BackgroundBox'
import { icons } from '../Icon/icons'
import { IconIndicator, IconIndicatorBackground } from '../IconIndicator/IconIndicator'

export interface IMessageBoxProps {
  icon: keyof typeof icons
  message: string
  description?: string
  iconBackground?: IconIndicatorBackground
  iconVariant?: 'decoration' | 'clickable'
  iconSize?: number
}

export const MessageBox: FC<IMessageBoxProps> = ({ icon, iconBackground, message, description, iconVariant, iconSize }) => {
  return (
    <BackgroundBox color="white" mb="xs" r noPadding height="messageBox">
      <PerFlexRow align="middle" noWrap className="fullHeight" mr="l" ml="l">
        <IconIndicator icon={icon} background={iconBackground} variant={iconVariant} iconSize={iconSize} />
        <PerSpacer ml="xs" mr="xs" />
        <PerFlexRow direction="column">
          <PerText mb="xxxs">{message}</PerText>
          {!!description && <PerText color="secondary-lighter">{description}</PerText>}
        </PerFlexRow>
      </PerFlexRow>
    </BackgroundBox>
  )
}
